import { createRelayResource } from '@townsquare/relay-utils';
import { ResourceContext } from '@townsquare/router';
import { isNavRefreshEnabled } from '@townsquare/stat-sig/nav4';

import TopicHeaderRefreshedQuery, {
  type TopicHeaderRefreshedQuery as TopicHeaderRefreshedQueryType,
} from '../ui/TopicHeaderRefreshed/__generated__/TopicHeaderRefreshedQuery.graphql';

export const topicViewHeaderResource = createRelayResource<TopicHeaderRefreshedQueryType>({
  getQuery: (routerContext, resourceContext) => {
    return {
      query: TopicHeaderRefreshedQuery,
      variables: {
        tagUuid: routerContext.match.params.uuid ?? '',
        trackViewEvent: 'DIRECT',
        isNavRefreshEnabled: isNavRefreshEnabled(resourceContext as ResourceContext),
      },
    };
  },
});
